import { CKSwitchNext } from 'clearkit';
import { FC, useState } from 'react';

import { useProfilePermissions } from '~/components/profile/useProfilePermissions';
import { SettingsCard } from '~/components/unified/SettingsCard';
import { AccountSuppressionSettings } from '~/generated/graphql';

import { SuppressableAPIType } from './types';

type APISuppressionSettingsProps = {
  onChange: (name: SuppressableAPIType) => void;
  value: AccountSuppressionSettings;
};

export const APISuppressionSettings: FC<APISuppressionSettingsProps> = ({
  onChange,
  value,
}) => {
  const [person, setPerson] = useState<boolean>(!!value?.person);
  const [prospector, setProspector] = useState<boolean>(!!value?.prospector);
  const { isOwner } = useProfilePermissions();
  const isEditDisabled = !isOwner;

  const rowClasses = 'grid gap-1 min-w-48';

  return (
    <SettingsCard>
      <SettingsCard.Header>
        <SettingsCard.Heading>Suppression Settings</SettingsCard.Heading>
        <p>
          Suppression settings allow you to exclude contact results with EU
          location data, or where location data is missing.{' '}
          <a
            className="ck-link"
            href="https://help.clearbit.com/hc/en-us/articles/360004989194"
          >
            Visit our help center for more information
          </a>
          .
        </p>
      </SettingsCard.Header>
      <SettingsCard.Body className="flex gap-4">
        <div className={rowClasses}>
          <h3 className="font-medium">Enrichment</h3>
          <CKSwitchNext
            checked={person}
            isDisabled={isEditDisabled}
            onChange={() => {
              setPerson(!person);
              onChange('person');
            }}
          >
            <CKSwitchNext.LabelDisabled>Inactive</CKSwitchNext.LabelDisabled>
            <CKSwitchNext.LabelEnabled>Active</CKSwitchNext.LabelEnabled>
          </CKSwitchNext>
        </div>
        <div className={rowClasses}>
          <h3 className="font-medium">Prospector</h3>
          <CKSwitchNext
            checked={prospector}
            isDisabled={isEditDisabled}
            onChange={() => {
              setProspector(!prospector);
              onChange('prospector');
            }}
          >
            <CKSwitchNext.LabelDisabled>Inactive</CKSwitchNext.LabelDisabled>
            <CKSwitchNext.LabelEnabled>Active</CKSwitchNext.LabelEnabled>
          </CKSwitchNext>
        </div>
      </SettingsCard.Body>
    </SettingsCard>
  );
};
